<template>
  <ValidationObserver v-slot="{ valid }">
    <unicom-filtro-v2
      titulo="Filtrar PTU"
      :value="mostrar"
      @limpar-filtro="limpar"
      @fechar="fecharFiltro"
      @filtrar="filtrar"
      :bloquearBotaoFiltro="!valid"
    >
      <div slot="corpo-subtitulo">
        Selecione os dados desejados,<br />
        depois clique em FILTRAR.
      </div>
      <div slot="corpo-filtro" style="margin: 0 32px">
        <unicom-linha espacamento class="fonte-secundaria espacamento-filtro">
          <unicom-coluna sm="12" class="linha-embaixo">
            <unicom-autocomplete
              mostrarIconeExcluir
              colorPlaceholder="#9E9E9E"
              placeholder="Selecione um analista"
              titulo="Analista responsável"
              v-model="objetoFiltro.analistaResponsavel.descricao"
              @index="
                index =>
                  selecionarChave(
                    index,
                    'analistaResponsavel',
                    listaAnalistas,
                    'id'
                  )
              "
              :items="listaAnalistas.map(e => e.nome)"
            />
          </unicom-coluna>
          <unicom-coluna sm="12" class="linha-embaixo">
            <unicom-autocomplete
              mostrarIconeExcluir
              colorPlaceholder="#9E9E9E"
              placeholder="Todos os status"
              titulo="Status do PTU"
              v-model="objetoFiltro.status.descricao"
              @index="index => selecionarChave(index, 'status', listaStatus)"
              :items="listaStatus.map(e => e.descricao)"
            />
          </unicom-coluna>
          <unicom-coluna sm="12" class="linha-embaixo">
            <unicom-autocomplete
              mostrarIconeExcluir
              colorPlaceholder="#9E9E9E"
              placeholder="Todas as Unimeds"
              titulo="Unimed Origem"
              v-model="objetoFiltro.unimedOrigem.descricao"
              @index="selecionarUnimed"
              :items="listaUnimedOrigem.map(e => e.textoExibicao)"
            />
          </unicom-coluna>
          <unicom-coluna sm="12" class="linha-embaixo">
            <unicom-campo-calendario
              mostrarIconeExcluir
              fecharClique
              posicao="top"
              colorPlaceholder="#9E9E9E"
              placeHolder="Selecione a data"
              tituloCampo="Data de envio inicial"
              :regrasValidacao="`validacaoDataPassada`"
              :customMessages="{ validacaoDataPassada: 'Data superior à hoje' }"
              v-model="objetoFiltro.dataEnvioInicial"
            />
          </unicom-coluna>
          <unicom-coluna sm="12" class="linha-embaixo">
            <unicom-campo-calendario
              mostrarIconeExcluir
              fecharClique
              posicao="top"
              :regrasValidacao="
                `validacaoDataPassada|validacaoDatafinalMaiorDataInicial: ${objetoFiltro.dataEnvioInicial}`
              "
              :customMessages="{ validacaoDataPassada: 'Data superior à hoje' }"
              colorPlaceholder="#9E9E9E"
              placeHolder="Selecione a data"
              tituloCampo="Data de envio final"
              v-model="objetoFiltro.dataEnvioFinal"
            />
          </unicom-coluna>
        </unicom-linha>
      </div>
    </unicom-filtro-v2>
  </ValidationObserver>
</template>

<script>
import FiltroMixin from "@/shared/mixin/FiltroMixin";
import { ValidationObserver } from "vee-validate";

export default {
  mixins: [FiltroMixin],
  components: {
    ValidationObserver
  },
  props: {
    listaStatus: {
      type: Array,
      default: () => []
    },
    listaUnimedOrigem: {
      type: Array,
      default: () => []
    },
    limparUnimed: {
      type: Boolean,
      default: false
    },
    listaAnalistas: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      objetoFiltro: {},
      objetoFiltroVazio: {
        status: {
          chave: "",
          descricao: ""
        },
        unimedOrigem: {
          chave: "",
          descricao: ""
        },
        analistaResponsavel: {
          chave: "",
          descricao: ""
        },
        dataEnvioInicial: "",
        dataEnvioFinal: ""
      }
    };
  },
  beforeMount() {
    this.objetoFiltro = JSON.parse(JSON.stringify(this.objetoFiltroVazio));
  },
  methods: {
    selecionarUnimed(index) {
      this.selecionarChave(index, "unimedOrigem", this.listaUnimedOrigem, "id");
      this.$emit("limpar-pesquisa");
    },
    filtrar() {
      const objetoFiltro = {
        status: this.objetoFiltro.status.chave,
        unimedOrigem: this.objetoFiltro.unimedOrigem.chave,
        dataEnvioInicial: this.$helpers.formatadorISO(
          this.objetoFiltro.dataEnvioInicial
        ),
        dataEnvioFinal: this.$helpers.formatadorISO(
          this.objetoFiltro.dataEnvioFinal
        ),
        analista: this.objetoFiltro.analistaResponsavel.chave
      };

      this.$emit("filtrar", objetoFiltro);
      this.$emit("filtroPuro", this.objetoFiltro);
    }
  },
  watch: {
    limparUnimed() {
      if (this.limparUnimed) {
        this.objetoFiltro.unimedOrigem = {
          chave: "",
          descricao: ""
        };
        this.$emit("unimed-limpada");
      }
    }
  }
};
</script>

<style lang="scss">
.espacamento-filtro {
  .col-12 {
    padding-top: 24px;
  }
}
</style>
